const visileColumns = [
  {
    title: "FirstName",
    field: "fname",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "LastName",
    field: "lname",
    locked: false,
    filter: "text",
    width: "150",
    show: true,
  },
  {
    title: "Qualification Descr",
    field: "Qyalify_descr",
    locked: false,
    filter: "text",
    width: "250",
    show: true,
  },
  {
    title: "Evaluation Rating",
    field: "evaluation_rating",
    locked: false,
    filter: "numeric",
    width: "180",
    show: true,
    className: "text-end",
  },
  {
    title: "Qualify",
    field: "qualify",
    locked: false,
    filter: "numeric",
    width: "180",
    show: true,
    className: "text-end",
    // headerClassName: "number-align",
  },
  {
    title: "Eligibility Remarks",
    field: "eligibility_remarks",
    locked: false,
    filter: "text",
    width: "180",
    show: true,
  },
  {
    title: "Update Status",
    field: "update_status",
    locked: false,
    filter: "text",
    width: "180",
    show: true,
  },
  {
    title: "Application Date",
    field: "application_date",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "180",
    show: true,
  },
  {
    title: "SSN",
    field: "emp_ssn",
    locked: false,
    filter: "text",
    width: "180",
    show: true,
  },
  {
    title: "Application ID",
    field: "application_id",
    locked: false,
    filter: "text",
    width: "220",
    show: true,
  },
];

export default visileColumns;
